import React from "react";
import { SpaceShape } from "venuescanner-js/react/shapes";

const Equation = ({ equation }) => (
  <React.Fragment>
    (<span title=" quick response">{equation.quick_response || 0}</span> +
    <span title=" slow response">{equation.slow_response || 0}</span> +
    <span title=" not responded">{equation.not_responded || 0}</span> +
    <span title=" responded">{equation.responded || 0}</span> +
    <span title=" booked">{equation.booked || 0}</span> +
    <span title=" subscription">{equation.sub || 0}</span> +
    <span title=" clp">{equation.clp || 0}</span> +
    <span title=" poa">{equation.poa || 0}</span> +
    <span title=" not poa">{equation.not_poa || 0}</span> +
    <span title=" active">{equation.active || 0}</span> +
    <span title=" updated boost">{equation.updated_boost || 0}</span> +
    <span title=" score boost">{equation.score_boost || 0}</span> +
    <span title=" not active">{equation.not_active || 0}</span>) x
    <span title=" random">{equation.random || 0}</span> =
  </React.Fragment>
);
const scorePointsMetrics = {
  responseTime: "response time",
  respondedThisWeek: "responsed this week",
  visitToBook: "Visit to book",
  impressionToEnquire: "Impr to enq",
  isNew: "Is new",
  pricing: "Pricing",
  subscription: "Subscription",
  payment: "VS Direct",
  owner: "Host",
  venueBoost: "Boost",
};
const reduceDecPlaces = (val) => {
  if (val === parseInt(val)) return val;
  return val.toFixed(1);
};
const Metrics = ({ scorePoints }) => {
  const items = [];
  Object.keys(scorePointsMetrics).forEach((key) => {
    if (scorePoints[key])
      items.push(
        <span
          className="equation-point"
          key={key}
          title={scorePointsMetrics[key]}
        >
          {reduceDecPlaces(scorePoints[key])}
        </span>
      );
  });
  return <React.Fragment>{items.filter((i) => i)}</React.Fragment>;
};

const SortScore = ({ space }) => (
  <div className="equation">
    {space.score ? (
      space.score.scorePoints ? (
        <Metrics scorePoints={space.score.scorePoints} />
      ) : (
        space.score.equation && <Equation equation={space.score.equation} />
      )
    ) : null}
    <b>{space.sort_points}</b>
  </div>
);

SortScore.propTypes = {
  space: SpaceShape.isRequired,
};

export default SortScore;
